var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { useSchedulerViewsContext } from '../../../main';
import { useSchedulerActiveViewContext } from '../../../context';
import { useLocalization } from '@progress/kendo-react-intl';
import { DropDownButton } from '@progress/kendo-react-buttons';
import { IconWrap, classNames, useWindow } from '@progress/kendo-react-common';
import { caretAltDownIcon } from '@progress/kendo-svg-icons';
import { ViewSelectorItem } from './ViewSelectorItem';
/** @hidden */
export var ViewSelectorList = React.forwardRef(function () {
    var element = React.useRef(null);
    var _a = React.useState('desktop'), media = _a[0], setMedia = _a[1];
    var views = useSchedulerViewsContext();
    var getWindow = useWindow(element);
    var _b = useSchedulerActiveViewContext(), activeViewName = _b[0], setActiveViewName = _b[1];
    var activeView = views.find(function (v) { return v.props.name === activeViewName; });
    var localization = useLocalization();
    var handleItemClick = React.useCallback(function (event) {
        if (!setActiveViewName) {
            return;
        }
        event.syntheticEvent.preventDefault();
        setActiveViewName(event.item.name);
    }, [setActiveViewName]);
    var calculateMedia = function () {
        if (getWindow().matchMedia) {
            setMedia(getWindow().matchMedia('(min-width: 1024px)').matches
                ? 'desktop'
                : 'mobile');
        }
    };
    React.useEffect(function () {
        calculateMedia();
        var resizeObserver = getWindow().ResizeObserver;
        var observer = resizeObserver && new resizeObserver(calculateMedia);
        if (observer) {
            observer.observe(element.current);
        }
        return function () {
            if (observer) {
                observer.disconnect();
            }
        };
    }, []);
    return (React.createElement("div", { className: classNames('k-toolbar-button-group k-button-group k-button-group-solid', {
            'k-scheduler-views': media === 'desktop',
            'k-scheduler-tools': media === 'mobile'
        }), role: 'group', ref: element },
        (activeView && media === 'mobile') && (React.createElement(DropDownButton, { className: "k-views-dropdown", onItemClick: handleItemClick, popupSettings: { popupClass: 'k-scheduler-toolbar' }, textField: "title", items: views.map(function (v) { return (__assign(__assign({}, v.props), { selected: v.props.name === activeViewName, title: typeof v.props.title === 'function'
                    ? v.props.title.call(undefined, localization)
                    : v.props.title })); }), text: (React.createElement(React.Fragment, null,
                typeof activeView.props.title === 'function'
                    ? activeView.props.title.call(undefined, localization)
                    : activeView.props.title,
                React.createElement(IconWrap, { name: "caret-alt-down", icon: caretAltDownIcon }))) })),
        (media === 'desktop') && (React.createElement(React.Fragment, null, views.map(function (view) { return (React.createElement(ViewSelectorItem, { key: view.props.name, view: view.props })); })))));
});
ViewSelectorList.displayName = 'KendoReactSchedulerViewSelectorList';
